/**
 * DIBAI 18K — Hero: Botón con retraso configurable
 * assets/hero-btn-delay.js  v2.0
 */
(function () {
  'use strict';

  var activeTimers = [];

  function clearAll() {
    activeTimers.forEach(clearTimeout);
    activeTimers = [];
  }

  function getHiddenClass(btn) {
    return btn.closest('.hfab-dibai__btn-wrap') ? 'hfab-dibai__btn--hidden' : 'hero-dibai__btn--hidden';
  }

  function getVisibleClass(btn) {
    return getHiddenClass(btn).replace('--hidden', '--visible');
  }

  function showBtn(btn) {
    btn.classList.remove(getHiddenClass(btn));
    btn.classList.add(getVisibleClass(btn));
    btn.style.pointerEvents = '';
  }

  function hideBtn(btn) {
    btn.classList.add(getHiddenClass(btn));
    btn.classList.remove(getVisibleClass(btn));
  }

  function scheduleBtn(btn) {
    var secs = parseFloat(btn.dataset.btnDelay) || 10;
    hideBtn(btn);
    var t = setTimeout(function () {
      showBtn(btn);
    }, secs * 1000);
    activeTimers.push(t);
  }

  function onSlideChange(slide) {
    // Esconder todos los botones con delay en todos los slides
    document.querySelectorAll('[data-btn-delay]').forEach(hideBtn);
    clearAll();
    // Activar solo el del slide recién activo
    var btn = slide.querySelector('[data-btn-delay]');
    if (btn) scheduleBtn(btn);
  }

  function initSection(section) {
    // Buscar slides dentro de esta sección
    var slides = section.querySelectorAll('.hero-dibai__slide, .hfab-dibai__slide');
    if (!slides.length) return;

    // Activar el slide inicial
    slides.forEach(function (slide) {
      if (slide.classList.contains('is-active')) {
        var btn = slide.querySelector('[data-btn-delay]');
        if (btn) scheduleBtn(btn);
      }
    });

    // Observar cambios de clase en cada slide
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName !== 'class') return;
        var slide = m.target;
        // Solo actuar cuando el slide SE VUELVE activo
        if (slide.classList.contains('is-active')) {
          onSlideChange(slide);
        }
      });
    });

    slides.forEach(function (slide) {
      observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function init() {
    // Buscar todos los wrappers posibles
    var wrappers = document.querySelectorAll(
      '.hero-dibai-wrapper, .hero-fab-dibai-wrapper, [class*="hero-dibai-wrapper"], [class*="hero-fab-dibai-wrapper"]'
    );

    // Fallback: si no hay wrappers, buscar directamente por slides
    if (!wrappers.length) {
      var slides = document.querySelectorAll('.hero-dibai__slide, .hfab-dibai__slide');
      if (slides.length) {
        // Crear sección virtual desde el ancestro común
        var parent = slides[0].closest('section') || document;
        initSection(parent);
      }
      return;
    }

    wrappers.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify editor
  document.addEventListener('shopify:section:load', function (e) {
    clearAll();
    // Buscar en el target y sus descendientes
    var w = e.target.querySelector('.hero-dibai-wrapper, .hero-fab-dibai-wrapper')
         || e.target.closest('.hero-dibai-wrapper, .hero-fab-dibai-wrapper')
         || e.target;
    initSection(w);
  });

  // También iniciar si el hero ya tiene slides visibles (para el editor en vivo)
  document.addEventListener('shopify:section:select', function (e) {
    var slide = e.target && e.target.closest('.hero-dibai__slide, .hfab-dibai__slide');
    if (slide && slide.classList.contains('is-active')) {
      onSlideChange(slide);
    }
  });

})();
